import React, { useState, useEffect } from 'react';
import {
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Typography,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { element } from 'prop-types';

const pickerStyles = {
  width: '100%',
};

const InfoSection = ({ shoppingCenters, typeInterview, companyCategories }) => {
  const { t } = useTranslation();
  const excludedCategoryValue = 17;
  const [selectAll, setSelectAll] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);

  useEffect(() => {
    if (selectAll) {
      setSelectedCategories(
        companyCategories
          .filter(category => category.value !== excludedCategoryValue)
          .map(category => category.value)
      );
    } else {
      setSelectedCategories([]);
    }
  }, [selectAll, companyCategories]);

  const handleCheckboxChange = (checkedValues) => {
    setSelectedCategories(checkedValues.filter(value => value !== excludedCategoryValue));
    setSelectAll(false);
  };

  const handleSelectAllChange = (e) => {
    setSelectAll(e.target.checked);
    setSelectedCategories(
      e.target.checked
        ? companyCategories
          .filter(category => category.value !== excludedCategoryValue)
          .map(category => category.value)
        : []
    );
  };
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{''}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Titolo')} name='title'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label={t('DATA INIZIO SONDAGGIO')} name='date_from'>
              <DatePicker format={'DD MMMM YYYY'} style={pickerStyles} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label={t('DATA FINE SONDAGGIO')} name='date_to'>
              <DatePicker format={'DD MMMM YYYY'} style={pickerStyles} />
            </Form.Item>
          </Col>
        </Row>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item label={t('Outlet Village')} name='shopping_center_id'>
          <Select placeholder={t('Selezioni opzione')}>
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            {shoppingCenters.map((shoppingCenter) => (
              <Select.Option key={shoppingCenter.id} value={shoppingCenter.id}>
                {shoppingCenter.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('DESTINATARI')} name='type_interview'>
          <Select placeholder={t('Selezioni opzione')}>
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            <Select.Option value='type_interview_company'>
              {t('INSEGNE')}
            </Select.Option>
            <Select.Option value='type_interview_clients'>
              {t('Clienti')}
            </Select.Option>
          </Select>
        </Form.Item>
      </Col>
      {typeInterview === 'type_interview_company' && (
        <Col offset={6} span={9}>
          <Form.Item
            name='company_category_ids'
            label={t('Selezione categorie stores su cui effettuare il sondaggio')}
          >
            <Checkbox
              indeterminate={selectedCategories.length > 0 && selectedCategories.length < companyCategories.length - 1}
              checked={selectAll}
              onChange={handleSelectAllChange}
            >
              {t('seleziona tutti').toUpperCase()}
            </Checkbox>
            <Checkbox.Group className='checkbox_group' value={selectedCategories} onChange={handleCheckboxChange}>
              <Row>
                {companyCategories.map((companyCategory) => (
                  <Col span={8} key={companyCategory.value}>
                    <Checkbox value={companyCategory.value}>
                      {companyCategory.title}
                    </Checkbox>
                  </Col>
                ))}
              </Row>
            </Checkbox.Group>
          </Form.Item>
          <Divider />
          <Form.Item valuePropName='checked' name='in_telegram'>
            <Checkbox>{t('Pubblicazione su Telegram')}</Checkbox>
          </Form.Item>
        </Col>
      )}
    </Row>
  );
};

export default React.memo(InfoSection);
